module.exports = __webpack_public_path__ + "img/arrow_down.7dce437b.svg";